import { config } from '../../config';
import Axios from 'axios';

const sessionStore = {
    namespaced: true,
    state: {
        apiToken: localStorage.getItem('apiToken') || null,
        impersonatedUser: localStorage.getItem('impersonatedUserInfo') ? JSON.parse(localStorage.getItem('impersonatedUserInfo')) : null,
        user: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : null,
        employers: [],
        features: null,
        initialized: false,
        error: null
    },
    getters: {
        loggedIn: state => !!state.apiToken,
        userId: (state) => {
            return state.user ? state.user.userId : null;
        },
        isInternalUser: (state) => {
            if (state.impersonatedUser) return state.impersonatedUser.isInternalUser;
            return state.user ? state.user.isInternalUser : false;
        },
        isFrontLinePX: (state) => {
          if (state.impersonatedUser) return false;
          return state.user ? state.user.tokenInfo.isFrontLinePX : false;
        },
        singleEmployer: (state) => {
            if (!state.employers) return false;
            return _.chain(state.employers).map(e => e.employerId).uniq().filter(e => e != null).value().length == 1;
        },
        roles: (state) => {
            if (state.impersonatedUser) return state.impersonatedUser.roles || [];
            if(state.user && state.user.tokenInfo) return state.user.tokenInfo.roles || [];
            return [];
        },
        linkToRome: (state) => {
            return `${config.romeUrl}/Account/Auth?token=${state.apiToken}&returnUrl=${config.romeUrl}`;
        },
        isMsr: (state, getters) => getters.roles.includes('msr'),
        isAdmin: (state, getters) => getters.roles.includes('admin'),
        isPlanAdmin: (state, getters) => getters.roles.includes('employer') && getters.roles.includes('planadmin'),
        isBroker: (state, getters) => getters.roles.includes('broker'),
        isInvoiceUser: (state, getters) => {
            var userRoles = getters.roles;
            return (userRoles.includes("employer")
              && !userRoles.includes("planadmin"))
              && (userRoles.includes("invoicetotals") || userRoles.includes("invoicetotals") || userRoles.includes("monthlyreporting"));
        },
        primaryRole: (state,getters) => {
            if (getters.roles.includes("planadmin")) return "planadmin";
            if (getters.roles.includes("broker")) return "broker";
            return getters.roles[0] || null;
        },
    },
    actions: {
        async init({ state, dispatch, commit, getters }, data) {
            if ((!state.initialized || (data && data.force)) && getters.loggedIn) {
                dispatch("loadRelatedEmployers");
                dispatch("loadApplicationFeatures");
                dispatch('addHotJarTag', ["Logged In"]);
                dispatch('addHotJarUserAttributes');
                this.dispatch("permissions/refresh");
                commit("setData", { initialized: true });
            }
        },
        async loadRelatedEmployers({ commit, state }) {
            let userId = state.impersonatedUser ? state.impersonatedUser.userId : state.user.userId;
            let result = await romeApi.get(`user/${userId}/employer`);
            commit('setUserEmployers', result);
        },
        async loadApplicationFeatures({ commit, state }) {
            let result = await romeApi.get(`config/feature`);
            commit('setApplicationFeatures', result);
        },
        async setImpersonatedUser(context, user) {
            context.state.impersonatedUser = user;
            localStorage.setItem('impersonatedUserInfo', JSON.stringify(user));
            context.dispatch("init", { force: true });
            this.dispatch("permissions/load");
        },
        async stopImpersonating(context) {
            localStorage.removeItem('impersonatedUserInfo');
            context.state.impersonatedUser = null;
            context.dispatch("init", { force: true });
            this.dispatch("permissions/load");
        },
        addHotJarTag({state, getters}, tags) {
            hj('tagRecording', tags);
        },
        addHotJarUserAttributes({ state, getters }) {
          hj('identify', state.user.userId, {
            roles: getters.roles.join(', ')
          });
        },
        setError({ commit }, data) {
          commit('setError', data);
        },
        async login({ dispatch, commit }, data) {
            localStorage.setItem('apiToken', data.apiToken);
            localStorage.setItem('userInfo', JSON.stringify(data.userInfo));
            commit("setData", { apiToken: data.apiToken, user: data.userInfo, error: null });
            await dispatch('init', { force: true });
        }
    },
    mutations: {
        setUserEmployers(state, employers) {
            state.employers = employers;
        },
        setApplicationFeatures(state, features) {
            state.features = features;
        },
        clear(state) {
            let apiToken = state.apiToken;
            let user = state.user;
            localStorage.removeItem('jitbit-session');
            localStorage.removeItem('apiToken');
            localStorage.removeItem('userInfo');
            localStorage.removeItem('impersonatedUserInfo');
            state.apiToken = null;
            state.impersonatedUser = null;
            state.user = null;
            state.employers = [];
            state.features = null;
            sendLogoutEventToServer(user, apiToken);
        },
        setError(state, data) {
          state.error = data;
        },
        setData(state, data) {
            utils.copyCommonProperties(data, state);
        },
    }
}

export default sessionStore;

async function sendLogoutEventToServer(user, apiToken) {
    if(user && apiToken) {
        var api = Axios.create({
            baseURL: config.romeApi,
            headers: { Authorization: `bearer ${apiToken}`}
        });
        try {
            await api.post(`user/${user.userId}/session-event?action=logout`)
        }
        catch(e) {}
    }
}



// WEBPACK FOOTER //
// ./src/framework/utils/session-store.js